import MultiLangsInterface from 'app/interfaces/MultiLangsInterface';
import {configStore} from 'app/store/global';

interface Langs {
    langs: MultiLangsInterface
}

export const langsValue = (obj: Langs, key: string): string => obj.langs[configStore.CURRENT_LOCALE] || obj[key];
